(function () {
  'use strict';

  const gid = (type, value) => {
    const text = String(value ?? '');
    return text.startsWith('gid://') ? text : `gid://shopify/${type}/${text}`;
  };

  const includesId = (values, numericId, type) => {
    if (!Array.isArray(values)) return false;
    const numeric = String(numericId ?? '');
    const full = gid(type, numeric);
    return values.some((value) => String(value) === numeric || String(value) === full);
  };

  const isPublicUnconditional = (offer) => {
    if (offer?.threshold || offer?.requires?.allOf?.length) return false;
    if (offer?.eligibility?.scope && offer.eligibility.scope !== 'everyone') return false;
    if (offer?.markets?.scope && offer.markets.scope !== 'all') return false;
    if (offer?.subscriptions?.applyToOneTimePurchases === false) return false;
    return true;
  };

  const targetsProduct = (offer, productId) =>
    includesId(offer?.discountOn?.productIds, productId, 'Product') ||
    includesId(offer?.discountOn?.resolvedProductIds, productId, 'Product');

  const productParticipates = (offer, productId) => {
    if (String(offer?.gift?.productId ?? '') === gid('Product', productId) || String(offer?.gift?.productId ?? '') === String(productId)) {
      return true;
    }

    return (offer?.requires?.allOf || []).some((group) => {
      const groupMatch =
        includesId(group?.productIds, productId, 'Product') ||
        includesId(group?.resolvedProductIds, productId, 'Product');
      const sourceMatch = (group?.anyOf || []).some(
        (source) =>
          includesId(source?.productIds, productId, 'Product') ||
          includesId(source?.resolvedProductIds, productId, 'Product'),
      );
      return groupMatch || sourceMatch;
    });
  };

  window.WindfallProductPromotion = function ({ productId, variantId, priceCents, compareAtCents }) {
    const contract =
      window.__WINDFALL_STOREFRONT_CONTRACT__ ||
      window.Windfall?.getContract?.() ||
      window.__WINDFALL_BOOTSTRAP__?.contract ||
      null;
    const rate = Number(window.Shopify?.currency?.rate) || 1;
    const catalogPrice = Number(priceCents) || 0;
    let effectivePrice = catalogPrice;
    let struckPrice = Number(compareAtCents) || 0;
    let automaticSale = false;
    let specialOffer = false;

    for (const offer of contract?.offers || []) {
      if (offer?.status !== 'active') continue;
      const unrestricted = isPublicUnconditional(offer);
      const participates = productParticipates(offer, productId);

      if (offer.type === 'product_percent' || offer.type === 'product_amount') {
        if (!targetsProduct(offer, productId)) {
          if (participates) specialOffer = true;
          continue;
        }
        if (!unrestricted) {
          specialOffer = true;
          continue;
        }

        let candidate = catalogPrice;
        if (offer.type === 'product_percent' && Number(offer.percent) > 0) {
          candidate = Math.round(catalogPrice * (1 - Number(offer.percent) / 100));
        } else if (offer.type === 'product_amount' && Number(offer.amount) > 0) {
          candidate = Math.max(0, catalogPrice - Math.round(Number(offer.amount) * rate * 100));
        }
        if (candidate < effectivePrice) {
          effectivePrice = candidate;
          automaticSale = true;
        }
        continue;
      }

      if (offer.type === 'quick_discount') {
        const productItems = (offer.items || []).filter((item) =>
          [String(productId), gid('Product', productId)].includes(String(item?.productId)),
        );
        if (!productItems.length) {
          if (participates) specialOffer = true;
          continue;
        }
        if (!unrestricted) {
          specialOffer = true;
          continue;
        }
        const item = productItems.find((entry) =>
          [String(variantId), gid('ProductVariant', variantId)].includes(String(entry?.variantId)),
        );
        if (item) {
          const candidate = Math.round(Number(item.salePrice) * rate * 100);
          if (Number.isFinite(candidate) && candidate < effectivePrice) {
            effectivePrice = candidate;
            automaticSale = true;
          }
        } else {
          specialOffer = true;
        }
        continue;
      }

      if (participates) specialOffer = true;
    }

    if (automaticSale && struckPrice < catalogPrice) struckPrice = catalogPrice;
    const savingPercent = struckPrice > effectivePrice && struckPrice > 0
      ? Math.round(((struckPrice - effectivePrice) / struckPrice) * 100)
      : 0;

    return { effectivePrice, struckPrice, savingPercent, automaticSale, specialOffer };
  };
})();
